import { defineStore } from "pinia";
import { useHttpStore } from "@/stores/http";

export const useQuizZoneStore = defineStore("quizzone", () => {
  const httpStore = useHttpStore()

  const saveMasterQuiz = (data) => {
    var params = {
      MasterTitle: data
    };
    return new Promise((resolve, reject) => {
      httpStore
        .api("post", "QuizZone/SaveMasterQuiz", params, {
          showLoading: true
        })
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    })
  }

  const getAdminQuizList = () => {
    var params = {
    };
   
    return new Promise((resolve, reject) => {
      httpStore
        .api("get", "QuizZone/GetAdminQuizList", params)
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const getAdminMasterTitles = (id) => {
    var params = {
      SearchBy: id,
    };
   
    return new Promise((resolve, reject) => {
      httpStore
        .api("get", "QuizZone/GetAdminMasterTitles", params)
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const getLanguages = () => {
    var params = {
    };
   
    return new Promise((resolve, reject) => {
      httpStore
        .api("get", "QuizZone/GetLanguages", params)
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  return {
    getAdminQuizList,
    getAdminMasterTitles,
    saveMasterQuiz,
    getLanguages
  };

})